import { useQuery } from '@tanstack/react-query';

export function useLatestVersionQuery({
  params = {},
  projectId,
  queryOptions,
}) {
  return useQuery({
    queryKey: ['projects', projectId, 'latestVersion', params],
    queryFn: async () => {
      const response = await axios.get(
        `/projects/${projectId}/latest_version`,
        { params },
      );

      return response.data;
    },
    ...queryOptions,
  });
}
